import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  prescriptionDone: false,
  notesDone: false,
  dsmDone: false,
  therapyDone: false,
  couponInfo: "",
  minvideoVisible: false,
  videoFullScreen: false,
  prescriptions: [],
  rmtParticipantDevice: "rmt_prtcp_web",
  updateData: {},
  publishClicked:{},
  reportFeedBackPublish:{}
};

const videoConsultationReducer = createSlice({
  name: "videoConsultationReducer",
  initialState,
  reducers: {
    setPrescriptionDone(state, action) {
      state.prescriptionDone = action.payload;
    },
    setNotesDone(state, action) {
      state.notesDone = action.payload;
    },
    setDsmDone(state, action) {
      state.dsmDone = action.payload;
    },
    setTherapyDone(state, action) {
      state.therapyDone = action.payload;
    },
    setCouponInfo(state, action) {
      state.couponInfo = action.payload;
    },
    setMinvideoVisible(state, action) {
      state.minvideoVisible = action.payload;
    },
    setVideoFullScreen(state, action) {
      state.videoFullScreen = action.payload;
    },
    setPrescriptions(state, action) {
      state.prescriptions = action.payload;
    },
    setUpdateData(state, action) {
      state.updateData = action.payload;
    },
    setRmtPrtcpDvc(state, action) {
      state.rmtParticipantDevice = action.payload;
    },
    setPublishClicked(state,action) {
      let { publishClicked } = state;   
      let incomingState = action.payload
      publishClicked = { ...publishClicked, ...incomingState }
      let finalObj = { ...state, publishClicked }
      Object.assign(state, finalObj)
    },
    setReportFeedBackPublish(state,action){
      let {  reportFeedBackPublish } = state;   
      let {app_id, ...data } = action.payload;
      let incomingState = {[app_id] : data};
      let groupData ={...reportFeedBackPublish?.[app_id],...incomingState?.[app_id]}
      let final = {[app_id] : groupData};
      reportFeedBackPublish = { ... reportFeedBackPublish, ...final }
      let finalObj = { ...state,  reportFeedBackPublish }
      Object.assign(state, finalObj)
    }
  },
});
export const {
  setPrescriptionDone,
  setNotesDone,
  setDsmDone,
  setTherapyDone,
  setCouponInfo,
  setMinvideoVisible,
  setPrescriptions,
  setVideoFullScreen,
  setRmtPrtcpDvc,
  setUpdateData,
  setPublishClicked,
  setReportFeedBackPublish
} = videoConsultationReducer.actions;
export default videoConsultationReducer.reducer;
